import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img-cms/logo@2x.png';
import _imports_1 from '@/assets/img-cms/icon/logout@2x.png';
const _hoisted_1 = {
  class: "cms-index"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "cms-logo",
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logout_icon",
  src: _imports_1
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "logout_text"
}, "退出登录", -1);
const _hoisted_5 = [_hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_header = _resolveComponent("el-header");
  const _component_Menu = _resolveComponent("Menu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
    class: "cms-layout-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "cms-layout-header"
    }, {
      default: _withCtx(() => [_hoisted_2, _createElementVNode("div", {
        class: "logout",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.logout())
      }, _hoisted_5)]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "cms-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        class: "cms-layout-aside"
      }, {
        default: _withCtx(() => [_createVNode(_component_Menu)]),
        _: 1
      }), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}